<template>
    <div>
        <div class="vx-row">
            <div class="vx-col lg:w-3/12 md:w-1/2 w-full">
                <vx-card id="channelData" class="vs-con-loading__container">
                    <div v-if="!channelEditing">
                        <table class="simple-table mt-6">
                            <tr>
                                <td class="font-semibold">Name:</td>
                                <td>{{ channel.name }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Category:</td>
                                <td>{{ channel.category }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">SID:</td>
                                <td>{{ channel.sid }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">EPG Provider:</td>
                                <td>{{ channel.epg_mapping }}</td>
                            </tr>
                        </table>
                        <img v-if="channel.image_id.length > 0" style="width: 100%; cursor: pointer" :src="'/api/management/v1/channel_logo/' + channel.image_id" :alt="channel.name" @click="channelEditing = true">
                        <vs-divider/>
                        <div class="flex justify-between">
                            <vs-button icon-pack="feather" icon="icon-arrow-left" color="primary" :disabled="channel.prev_channel_id === 0" @click="openChannel(channel.prev_channel_id)"/>
                            <vs-button icon-pack="feather" icon="icon-edit" color="warning" @click="channelEditing = true">Edit</vs-button>
                            <vs-button icon-pack="feather" icon="icon-arrow-right" color="primary" :disabled="channel.next_channel_id === 0" @click="openChannel(channel.next_channel_id)"/>
                        </div>
                    </div>
                    <div v-else>
                        <p>Name</p>
                        <vs-input v-model="editName" class="w-full mb-4"></vs-input>
                        <p>Category</p>
                        <vs-input v-model="editCategory" class="w-full mb-4"></vs-input>
                        <p>SID</p>
                        <vs-input v-model="editSID" class="w-full mb-4"></vs-input>
                        <img v-if="editLogo.length > 0 && !newLogoUpload" style="width: 100%; cursor: pointer" :src="'/api/management/v1/channel_logo/' + editLogo" :alt="editName" @click="newLogoUpload = true">
                        <vs-upload v-if="newLogoUpload || editLogo.length === 0" text="Upload logo" :automatic="true" limit="1" fileName="file" :action="'/api/management/v1/channel_logo/'" @on-success="imageUploaded" />
                        <vs-divider/>
                        <vs-button style="float:left" icon-pack="feather" icon="icon-save" color="success" class="mr-3 mb-3" @click="saveChannel">Save</vs-button>
                        <vs-button style="float:left" icon-pack="feather" icon="icon-x" color="danger" class="mr-3 mb-3" @click="cancelEdit">Stop editing</vs-button>
                        <vs-button style="float:right" icon-pack="feather" icon="icon-trash-2" color="danger" class="mr-1 mb-3" @click="removeChannel"></vs-button>
                        <div style="clear:left;"></div>
                    </div>
                </vx-card>
            </div>
        </div>
        <vs-divider/>

        <h4 class="mb-6">IPTV Sources</h4>
        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addSourcePrompt = true">Add</vs-button>
        <sources-table ref="sourcesTable" :sources-u-r-l="'/api/management/v1/channel/' + this.$route.params.id + '/source'" :marked-sources="sourcesInUse"/>

        <vs-divider/>

        <e-p-g-entries :channel-id="Number($route.params.id)"/>

        <watch-statistics-daily class="mt-6" :link="'/api/management/v1/watch_statistics/daily/by_channel/' + $route.params.id"/>

        <watch-statistics-bars class="mt-6" :link="'/api/management/v1/watch_statistics/bar_chart/by_channel/'  + $route.params.id" info-text="Only top 50 clients are displayed!"/>

        <vs-popup title="Add source" :active.sync="addSourcePrompt">
            <div id="addSourceDiv" class="vs-con-loading__container" >
                <vs-checkbox class="mt-3" v-model="addObject['checker_enabled']">Enable checker</vs-checkbox>
                <p class="mt-6">URL</p>
                <vs-input v-model="addObject['url']" class="w-full"></vs-input>
                <p class="mt-6">Provider</p>
                <vs-select autocomplete class="w-full" v-model="addObject['provider_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in providers" />
                </vs-select>
                <p class="mt-6">Allowed location</p>
                <vs-select autocomplete class="w-full" v-model="addObject['location_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in locations" />
                </vs-select>
                <p class="mt-6">Input template</p>
                <vs-select autocomplete class="w-full" v-model="addObject['in_template']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in inputTemplates" />
                </vs-select>
                <div v-if="templateMap[addObject['in_template']] && templateMap[addObject['in_template']].params.length > 0">
                    <h6 class="mt-6">Template parameters</h6>
                    <div class="w-full vx-row mb-4" :key="item.key" v-for="item in templateMap[addObject['in_template']].params">
                        <div class="vx-col w-1/2">
                            <vs-checkbox class="mt-3" v-model="enabledParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                        </div>
                        <div class="vx-col w-1/2">
                            <vs-input v-if="enabledParameters.includes(item.key)" v-model="parameterValues[item.key]" class="w-full"></vs-input>
                            <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                        </div>

                    </div>
                </div>

                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addSource">Add</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>

    import SourcesTable from '../Sources/SourcesTable'
    import EPGEntries from './EPGEntries'
    import WatchStatisticsDaily from '@/views/WatchStatistics/WatchStatisticsDaily'
    import WatchStatisticsBars from '@/views/WatchStatistics/WatchStatisticsBars'
    export default {
        components: { WatchStatisticsBars, WatchStatisticsDaily, EPGEntries, SourcesTable },
        data() {
            return {

                itemsPerPage: 20,
                isMounted: false,

                channelEditing: false,
                newLogoUpload: false,

                channel: {
                    name: '',
                    image_id: ''
                },

                editName: '',
                editCategory: '',
                editLogo: '',
                editSID: '',

                addSourcePrompt: false,
                inputTemplates: [],
                providers: [],

                addObject: {
                    location_id: 0
                },
                enabledParameters: [],
                parameterValues: {},

                locations: [],

                sourcesInUse: [],

                dataLoaded: false

            }
        },
        methods: {
            imageUploaded(data) {
                this.newLogoUpload = false
                this.editLogo = data.target.response
            },
            cancelEdit() {
                this.editName = this.channel.name
                this.editLogo = this.channel.image_id
                this.channelEditing = false
                this.newLogoUpload = false
            },
            loadFullData() {
                this.loadAdditionalData()
                this.loadData()
            },
            loadData() {
                this.$vs.loading({
                    container: '#channelData',
                    type: 'corners',
                    scale: 0.7
                })

                this.loadSourcesInUse()

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/channel/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.channel = response.data
                    thisIns.editName = thisIns.channel.name
                    thisIns.editCategory = thisIns.channel.category
                    thisIns.editLogo = thisIns.channel.image_id
                    thisIns.editSID = thisIns.channel.sid
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise]).then(function() {
                    thisIns.dataLoaded = true
                }).finally(function() {
                    thisIns.$vs.loading.close('#channelData > .con-vs-loading')
                })
            },
            loadAdditionalData() {
                const thisIns = this
                const templatesPromise = this.$http.get('/api/management/v1/template/?type=0')
                templatesPromise.then(function(response) {
                    thisIns.inputTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const providersPromise = this.$http.get('/api/management/v1/provider/')
                providersPromise.then(function(response) {
                    thisIns.providers = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const loadLocationsPromise = this.$http.get('/api/management/v1/location/')
                loadLocationsPromise.then(function(response) {
                    thisIns.locations = [{ id: 0, name: 'Any' }].concat(response.data)
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            loadSourcesInUse() {
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/source/?inUse=true')
                loadPromise.then(function(response) {
                    thisIns.sourcesInUse = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            saveChannel() {
                this.$vs.loading({
                    container: '#channelData',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.put('/api/management/v1/channel/' + this.$route.params.id, {
                    name: this.editName,
                    category: this.editCategory,
                    image_id: this.editLogo,
                    sid: this.editSID
                })

                loadPromise.then(function() {
                    thisIns.$printSuccess('Channel saved')
                    thisIns.cancelEdit()
                    thisIns.loadData()
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#channelData > .con-vs-loading')
                })
            },
            removeChannel() {
                this.$vs.loading({
                    container: '#channelData',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.delete('/api/management/v1/channel/' + this.$route.params.id)
                loadPromise.then(function() {
                    thisIns.$printSuccess('Channel removed')
                    thisIns.$vs.loading.close('#channelData > .con-vs-loading')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/channels/')
                    })
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#channelData > .con-vs-loading')
                })
            },
            addSource() {
                this.$vs.loading({
                    container: '#addSourceDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const params = []

                for (let i = 0; i < this.enabledParameters.length; i++) {
                    if (this.parameterValues.hasOwnProperty(this.enabledParameters[i])) {
                        params.push({
                            key: this.enabledParameters[i],
                            value: this.parameterValues[this.enabledParameters[i]]
                        })
                    }
                }

                const selectedTemplate = {
                    id: Number(this.addObject.in_template),
                    params: params
                }

                const addPromise = this.$http.post('/api/management/v1/source/', {
                    channel_id: Number(this.$route.params.id),
                    provider_id: Number(this.addObject.provider_id),
                    location_id: Number(this.addObject.location_id),
                    in_template: selectedTemplate,
                    url: this.addObject.url,
                    checker_enabled: this.addObject.checker_enabled
                })

                addPromise.then(function() {
                    thisIns.$refs.sourcesTable.reloadSources()
                    thisIns.addSourcePrompt = false
                    thisIns.$printSuccess('Source added')
                    thisIns.addObject.url = ''
                    thisIns.$vs.loading.close('#addSourceDiv > .con-vs-loading')
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#addSourceDiv > .con-vs-loading')
                })
            },
            openChannel(id) {
                this.$router.push('/channel/' + id)
            }
        },
        watch: {

            '$route.params.id'() {
                this.loadData()
            }
        },
        computed: {
            templateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.inputTemplates.length; i++) {
                    templatesMap[this.inputTemplates[i].id] = this.inputTemplates[i]
                }

                return templatesMap
            },
            channelMap() {
                const channelMap = {}
                for (let i = 0; i < this.channels.length; i++) {
                    channelMap[this.channels[i].id] = this.channels[i]
                }

                return channelMap
            }
        },
        mounted() {
            this.loadFullData()
        },
        beforeRouteLeave(to, from, next) {
            if (this.addSourcePrompt) {
                this.addSourcePrompt = false
                next(false)
            } else {
                next()
            }
        }
    }

</script>
<style lang="scss" scoped>
    .simple-table {
        td {
            vertical-align: top;
            min-width: 125px;
            padding-bottom: 0.5rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

</style>
